import { render, staticRenderFns } from "./LuSpecialDistrictDialog.vue?vue&type=template&id=86b3b988&"
import script from "./LuSpecialDistrictDialog.vue?vue&type=script&lang=js&"
export * from "./LuSpecialDistrictDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports